<template>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    autofocus
                    class="form-control"
                    v-model="search"
                    @input="(val) => searchChange(val)"
                    :placeholder="$t(`site.search`)"
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="float-md-right pt-1">
                  <span class="text-muted text-small mr-1 mb-2">
                    {{ from }}:{{ to }}
                  </span>
  
                  <b-dropdown
                    id="ddown2"
                    right
                    :text="`${perPage}`"
                    variant="outline-warning"
                    size="xs"
                  >
                    <b-dropdown-item
                      v-for="(size, index) in [5, 10, 20, 50, 100]"
                      :key="index"
                      @click="changePageSize(size)"
                      >{{ size }}</b-dropdown-item
                    >
                  </b-dropdown>
                  <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-dropdown v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                  :text="$t('quran_programs.teachers')"
                  variant="flat-primary">
                    <!--Teachers dropdown-->
                  <b-dropdown-item v-for="teacher in teachers" @click="filterTeachers(teacher.id)">
                    {{ teacher.name  }}
                  </b-dropdown-item>
                </b-dropdown>
               
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 overflow-auto">
                <b-card>
                  <b-table
                  :stacked="$mobile == 1" responsive ref="table" class="vuetable" sort-by="id"
                  sort-desc.sync="false" :current-page="currentPage" :fields="bootstrapTable.fields"
                  :items="dataProvider" style="min-height: 250px"
                  >
                    <template #cell(checkbox)="data">
                      <label
                        class="kt-checkbox kt-checkbox--single kt-checkbox--solid"
                      >
                        <input
                          type="checkbox"
                          v-model="recordIds"
                          :value="data.item.id"
                          @change="selectItem(data)"
                        />
                        <span></span>
                      </label>
                    </template>
  
                    <template #cell(room_type)="data">
                      <b-badge
                        variant="light-info"
                        v-if="data.item.room_type == 0"
                      >
                        {{ $t("quran_programs.group") }}
                      </b-badge>
                      <b-badge variant="light-dark" v-else>
                        {{ $t("quran_programs.single") }}
                      </b-badge>
                    </template>
  
                    <template #cell(reading_type)="data">
                      {{data.item.program != null ? 
                      data.item.program.reading_type == '1' ? 'رواية حفص' : 'رواية ورش'
                      : ''}}
                       <!-- <b-badge
                        variant="light-info"
                        v-if="data.program.reading_type == '1'"
                      >
                        رواية حفص
                      </b-badge>
                      <b-badge variant="light-dark" v-else>
                        رواية ورش
                      </b-badge>  -->
                    </template>

                    <template #cell(student_mobile)="data">
                      {{ data.item.student ?  data.item.student.mobile :'' }}
                    </template>
                   
                    <template #cell(teacher_name)="data">
                      {{( data.item.teacher ? data.item.teacher.first_name : '') + " " +  (data.item.teacher ?  data.item.teacher.last_name : '' )}}
                    </template>
                    <template #cell(student_name)="data">
                      {{( data.item.student ? data.item.student.first_name : '') + " " +  (data.item.student ?  data.item.student.last_name : '' )}}
                    </template>
                   
                    <template #cell(SaveType)="data">
                      <b-badge
                        variant="primary"
                      >
                        {{ data.item.SaveType == "asc" ? "تنازلي" : "تصاعدي" }}
                      
                       
                      </b-badge>
                    </template>
                    <!-- Removed birthdate -->
  
                    
                 
                    <template #cell(draft)="data">
                      <b-badge
                        variant="light-success"
                        v-if="data.item.draft == 1"
                      >
                        تم تفعيل مقرأة
                      </b-badge>
                      <template v-else>
                        <b-button
                          variant="success"
                          v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                          @click="setDraft(data.item)"
                        >
                          تفعيل
                        </b-button>
                        <b-badge variant="light-danger" v-else>
                          انتظار التفعيل
                        </b-badge>
                      </template>
                    </template>
                    <template #cell(report)="data">
                      <b-button>تقرير </b-button>
                    </template>
                    <template #cell(edit)="data">
                      <b-dropdown
                        :text="$t('site.action')"
                        variant="flat-primary"
                        v-if="data.item.draft == 1"
                      >
                        <b-dropdown-item
                          v-if="
                            data.item.quran_schedule_date.length > 0 &&
                              data.item.quran_schedule_date[0].teachers.length > 0
                          "
                          :to="{
                            name: 'QuranScheduleDateSystemic',
                            params: { id: data.item.id },
                          }"
                        >
                          {{ $t("quran_programs.live_meetings") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                          variant="outline-success"
                          v-b-modal.modal-info
                          v-if="$role == 'super_admin' || $role == 'QuranAdmin'"
                          @click="
                            openAssign(
                              data.item,
                              'teacher',
                              'عرض اعضاء هيئة التدريس '
                            )
                          "
                        >
                          اعضاء هيئة التدريس
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                  <b-spinner
                    v-if="load"
                    type="grow"
                    label="Loading..."
                    class="loading"
                  />
                </b-card>
              </div>
              <!-- end of col -->
            </div>
  
            <hr />
            <b-pagination
              size="sm"
              class="dataTables_paginate paging_simple_numbers pagination-warning"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            >
              <template v-slot:next-text>
                <i class="fas fa-angle-left" />
              </template>
              <template v-slot:prev-text>
                <i class="fas fa-angle-right" />
              </template>
              <template v-slot:first-text>
                <i class="fas fa-step-forward" />
              </template>
              <template v-slot:last-text>
                <i class="fas fa-step-backward" />
              </template>
            </b-pagination>
            <!-- end of row -->
            <b-modal
              id="modal-info"
              ok-variant="info"
              ok-title="save"
              modal-class="modal-info"
              centered
              @ok="save"
              size="lg"
              :title="title"
            >
              <b-table
                :stacked="$mobile == 1"
                :items="users"
                :fields="userfields"
              >
                <template #cell(checkbox)="data">
                  <b-form-checkbox v-model="usersSelelcted" :value="data.item.id">
                  </b-form-checkbox>
                </template>
              </b-table>
  
              <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import QuranScheduleDateUser from "@/Controllers/QuranScheduleDateUserController";
import QuranScheduleDate from "@/Controllers/QuranScheduleDateController";
import UsersController from "@/Controllers/UsersController";
import flatPickr from "vue-flatpickr-component";
import Auth from "../../../Apis/Auth";

export default {
  name: "QuranProgramsDataTable",
  props: ["items", "editItem"],
  components: {
    flatPickr,
  },
  data() {
    return {
      teachers: [],
      dateNtim: null,
      schedules: [],
      itemView: "DataTable",
      controller: new QuranScheduleDateUser(),
      title: "",
      newDate: {},
      draft: 1,
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "reading_type",
            label: "الرواية",
            sortable: false,
          },
          {
            key: "student_name",
            label: this.$i18n.t("quran_programs.students"),
            sortable: false,
          },
          {
            key: "student.email",
            label: this.$i18n.t("users.email"),
            sortable: false,
          },
          {
            key: "student.gander",
            label: this.$i18n.t("students.gander"),
            sortable: true,
          },
          {
            key: "student_mobile",
            label: "رقم الهاتف",
            sortable: true,
          },
        ],
      },
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 15,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      users: {},
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
      programSelelcted: {},
    };
  },
  async created() {
    //get user_type
    if (Auth.USER.account_type == "teacher") {
      this.params.filter = "teacher_id|" + Auth.USER.id;
    } else {
      this.bootstrapTable.fields.push({
        key: "teacher_name",
        label: "معلم",
        sortable: false,
      });

      this.teachers = await this.controller.GetTeachersOptions();
    }
    // this.itemView = "grid-view";
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
    // systemic
    // this.users = await new UsersController().GetAll({
    //   type: "teacher",
    //   filter: filter,
    // });
    this.dataProvider(this.params);
  },

  methods: {
  async setDraft(item) {
    await this.controller.Updata({ id: item.id, draft: 1 });
    this.$refs.table.refresh();
  },
  refresh() {
    this.$refs.table.refresh();
  },
  onPaginationData(paginationData) {
    this.$refs.pagination.setPaginationData(paginationData);
  },
  onChangePage(page) {
    this.currentPage = page;
    this.$refs.table.refresh();
  },
  async dataProvider(ctx) {
    this.load = true;
    let filter = false;
    let t_id = null;

    if(this.params.filter && this.params.filter.indexOf('teacher_id') > -1){
      filter = true;
      t_id = this.params.filter.split('|')[1];
    }
    this.params = ctx;

    if(filter){
      this.params.filter = 'teacher_id|' + t_id;
    }

    const data = await this.controller.GetTeacherStudents(this.apiParamsConverter());
    this.currentPage = data.current_page;
    this.perPage = data.per_page;
    this.totalRows = data.total;
    this.from = data.from;
    this.to = data.to;
    this.total = data.total;
    this.data = data.data;
    this.load = false;
    return data.data;
  },
  filterTeachers(id) {
    this.params.filter = 'teacher_id|' + id;
    this.$refs.table.refresh();
  },
  apiParamsConverter() {
    let apiParams = { per_page: this.perPage };
    if (this.currentPage >= 1) {
      apiParams.page = this.currentPage;
    }
    if (this.params.sortBy && this.params.sortBy.length > 0) {
      apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"}`;
    }
    if (this.params.sort) {
      apiParams.sort = this.params.sort;
    }
    if (this.params.filter && this.params.filter.length > 0) {
      apiParams.filter = this.params.filter;
    }
    if (this.search !== "") {
      apiParams.custom_search = this.search;
    }
    if (this.params.teacher_id) {
      apiParams.teacher_id = this.params.teacher_id;
    }
    return apiParams;
  },
  changePageSize(perPage) {
    this.page = 1;
    this.perPage = perPage;
    this.$refs.table.refresh();
  },
  searchChange() {
    if (this.search.length == 0) {
      this.$refs.table.refresh();
    }
    if (this.search.length < 2) return;
    this.page = 1;
    this.$refs.table.refresh();
  },
  async save() {
    this.studentsLoad = true;
    await new QuranScheduleDate().assignTeacherDate(
      this.programSelelcted.quran_schedule_date[0].id,
      {
        teacher_ids: this.usersSelelcted,
      }
    );
    this.studentsLoad = false;
    this.usersSelelcted = [];
    this.programSelelcted = {};
  },
  async openAssign(item, type, title) {
    this.title = title;
    this.programSelelcted = item;

    this.studentsLoad = true;
    this.usersSelelcted = item.quran_schedule_date[0].teachers.map(
      (x) => x.id
    );

    this.studentsLoad = false;
  },
}

};

  </script>
  <style lang="scss">
  @import "@core/scss/base/pages/app-ecommerce.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  </style>
  
  <style lang="scss" scoped>
  .item-view-radio-group ::v-deep {
    .btn {
      display: flex;
      align-items: center;
    }
  }
  </style>
  